import React from 'react';

export const OkIcon = () => (
  <svg width="14" height="11" viewBox="0 0 14 11" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M4.9 9L4.19289 9.70711L4.89562 10.4098L5.6027 9.71148L4.9 9ZM0.292893 5.80711L4.19289 9.70711L5.60711 8.29289L1.70711 4.39289L0.292893 5.80711ZM5.6027 9.71148L13.7027 1.71149L12.2973 0.288515L4.1973 8.28852L5.6027 9.71148Z" fill="#4CAF50" />
  </svg>
);
